"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _distributorsList = _interopRequireDefault(require("./distributors-list"));

var _components = require("./components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])),
  distributors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    companies: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
      name: _propTypes.string,
      url: _propTypes.string
    })),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    region: _propTypes.string
  })),

  /** hide dropdown boolean */
  hideDropdown: _propTypes.bool,
  onChangeHandler: _propTypes.func,
  onClick: _propTypes.func,
  position: _propTypes.string,
  title: _propTypes.string
};

var DistributorsDropdown = function DistributorsDropdown(_ref) {
  var containerProps = _ref.containerProps,
      distributors = _ref.distributors,
      _ref$hideDropdown = _ref.hideDropdown,
      hideDropdown = _ref$hideDropdown === void 0 ? false : _ref$hideDropdown,
      onChangeHandler = _ref.onChangeHandler,
      onClick = _ref.onClick,
      position = _ref.position,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], {
    containerProps: Object.assign({
      mt: 1
    }, containerProps),
    hideDropdown: hideDropdown,
    onClick: onClick,
    position: position,
    render: function render(_ref2) {
      var show = _ref2.show;
      return /*#__PURE__*/_react["default"].createElement(_components.DropdownTitle, {
        show: show
      }, title);
    },
    renderDropdown: function renderDropdown(_ref3) {
      var firstRef = _ref3.firstRef,
          returnFocus = _ref3.returnFocus,
          toggleShowDropdown = _ref3.toggleShowDropdown;
      return distributors ? /*#__PURE__*/_react["default"].createElement(_distributorsList["default"], {
        distributors: distributors,
        firstRef: firstRef,
        onChangeHandler: onChangeHandler,
        returnFocus: returnFocus,
        toggleShowDropdown: toggleShowDropdown
      }) : null;
    }
  });
};

DistributorsDropdown.propTypes = propTypes;
DistributorsDropdown.displayName = "Modules.SearchDropdown";
var _default = DistributorsDropdown;
exports["default"] = _default;